module.exports = __webpack_public_path__ + "img/payment_visa_md.d180b19d.jpg";